import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  error: false,
  disputes: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_OPEN_DISPUTE:
      return {
        ...state,
        isLoading: true,
        error: false,
        disputes: [],
      };
    case types.RECEIVE_OPEN_DISPUTE_ERROR:
      return {
        ...state,
        isLoading: false,
        error: true,
        disputes: [],
      };
    case types.RECEIVE_OPEN_DISPUTE:
      return {
        ...state,
        isLoading: false,
        error: false,
        disputes: action.payload,
      };
    default:
      return state;
  }
}
